// Rappel heatpack (Provost Orchids) — voir snippets/heatpack-reminder.liquid.
// Ajoute UN heatpack au panier. Sur la page panier : recharge la page pour mettre a jour
// les totaux. Dans la fenetre de notification : confirme et met a jour le compteur du panier.
if (!customElements.get('heatpack-reminder')) {
  customElements.define(
    'heatpack-reminder',
    class HeatpackReminder extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.heatpack-reminder__button');
        this.message = this.querySelector('.heatpack-reminder__message');
        if (this.button && !this.button.dataset.bound) {
          this.button.dataset.bound = 'true';
          this.button.addEventListener('click', () => this.add());
        }
      }

      showMessage(templateClass) {
        const template = this.querySelector(templateClass);
        if (!template || !this.message) return;
        this.message.innerHTML = template.innerHTML.trim();
        this.message.hidden = false;
      }

      async add() {
        if (this.button.getAttribute('aria-busy') === 'true') return;
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;

        const onCartPage = Boolean(document.getElementById('main-cart-items'));
        const addUrl = `${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`;

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
              sections: 'cart-icon-bubble,cart-notification-button',
              sections_url: window.location.pathname,
            }),
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const data = await response.json();

          if (onCartPage) {
            window.location.reload();
            return;
          }

          // Met a jour le compteur du panier et le bouton « Voir le panier (n) »
          ['cart-icon-bubble', 'cart-notification-button'].forEach((id) => {
            const html = data.sections && data.sections[id];
            const target = document.getElementById(id);
            if (!html || !target) return;
            const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (inner) target.innerHTML = inner.innerHTML;
          });
          this.button.remove();
          this.showMessage('.heatpack-reminder__added');
        } catch (error) {
          console.error('[heatpack-reminder]', error);
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.showMessage('.heatpack-reminder__error');
        }
      }
    }
  );
}
